import React from 'react';
import styles from './GameDetailsHeader.module.scss';
import HeaderBackButton from '../Header/HeaderBackButton';
import { HeaderProps } from '../Header/types';

interface GameDetailsHeaderPropsType {
  backButtonText: HeaderProps['backButtonText'];
  onBackButtonClick: HeaderProps['onBackButtonClick'];
}

const GameDetailsHeader: React.FC<GameDetailsHeaderPropsType> = ({
  backButtonText,
  onBackButtonClick,
}) => {
  return (
    <div
      className={styles.headerWrapper}
      data-testid="game-details-simple-header"
    >
      <HeaderBackButton
        backButtonText={backButtonText}
        onBackButtonClick={onBackButtonClick}
      />
    </div>
  );
};

export default GameDetailsHeader;
